// src/app/core/mainPage/mainPagecomp/TopModelsSection/TopModelCard.tsx
import { motion } from "motion/react";
import { Sparkles} from "lucide-react";
import type { TopModelCategoryData } from "./types";

interface TopModelCardProps {
  data: TopModelCategoryData;
  category: 'text' | 'image' | 'video';
  onSelect: () => void;
}

export function TopModelCard({ data, category, onSelect }: TopModelCardProps) {
  const isText = category === 'text';
  const showMedia = !isText && data.background;

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.97 }}
      onClick={onSelect}
      className="relative w-full h-40 rounded-2xl overflow-hidden border border-border shadow-md focus:outline-none focus:ring-2 focus:ring-accent"
    >
      {isText && (
        <div className="absolute inset-0 bg-gradient-to-br from-violet-500/20 to-indigo-600/20 dark:from-violet-500/10 dark:to-indigo-600/10">
          <div className="absolute inset-0 bg-muted/30 backdrop-blur-[2px]" />
        </div>
      )}

      {showMedia && (
        <img
          src={data.background}
          alt={data.name}
          className="absolute inset-0 w-full h-full object-cover" 
        />
      )}

      <div
        className={`absolute inset-0 bg-gradient-to-t ${
          isText ? 'from-black/50 to-transparent' : 'from-black/70 via-black/30 to-black/20'
        }`}
      />

      <div className="absolute bottom-0 left-0 right-0 p-3 text-left text-white">
        <div className="flex items-center gap-1.5 mb-1">
          <Sparkles className="w-3.5 h-3.5 text-accent" />
          <span className="text-sm font-bold drop-shadow">{data.name}</span>
        </div>
        <p className="text-xs text-white/80 line-clamp-2 drop-shadow">
          {data.description}
        </p>
      </div>
    </motion.button>
  );
}